// components/FormHeader.jsx
import React from 'react';

const FormHeader = ({ isEditMode, currentPage, totalPages }) => {
  return (
    <div className="modal-header border-bottom">
      <div className="w-100">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h1 className="modal-title fs-5">
            {isEditMode ? "Modifier le Compte" : "Créer un Compte"}
          </h1>
          <span className="badge bg-primary">
            Page {currentPage + 1} sur {totalPages}
          </span>
        </div>
        
        {/* Message important sur les champs obligatoires */}
        <div className="alert alert-info py-4 mb-0">
          <small>
            <i className="fas fa-info-circle me-2"></i>
            <strong>Information importante :</strong> Tous les champs marqués d'un 
            <span className="text-danger mx-1">*</span> 
            sont obligatoires. Les autres champs sont optionnels.
          </small>
        </div>
      </div>
      <button 
        type="button" 
        className="btn-close" 
        data-bs-dismiss="modal" 
        aria-label="Close"
      ></button>
    </div>
  );
};

export default FormHeader;